<template>
  <div class="columns is-marginless" v-if="recom">
    <div class="column is-height-650px pa-40  has-text-white havasBackground">
      <div class="is-relative is-height-50p is-flex flex-end-align-center is-border-bottom-or">
        <img :src="func.getImg(logoSociete)" class="logo-havas-pg-recom mb-4px0" />
      </div>
      <div class="is-height-50p pt-60 has-text-centered">
        <img v-if="pointDeVente" :src="func.getImg(pointDeVente.srcImg)" width="200" class="">
      </div>
    </div>
    <div class="column is-height-650px pa-40 has-text-grid-1">
      <div class="is-height-50p is-flex flex-end is-border-bottom-or">
        <h4 class="is-size-4 has-text-weight-bold mb-65">
          {{recom.theme}}
        </h4>
      </div>
      <div class="is-height-50p pt-65 is-relative" v-if="commercial">
        <h5 class="is-size-5 has-text-weight-bold"> {{ commercialName }} </h5>
        <p class="is-size-18px">{{ profil }}</p>
        <p class="is-size-18px">{{ commercial.telephone ? commercial.telephone : '' }}</p>
        <p class="is-size-18px">{{ commercial.email }}</p>
        <p class="is-size-7 position-date-pg-recom">
          {{ func.formatDate(recom.creationTime) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { getImg, formatDate } from '@/services/general/general';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    recom: Object,
    pointDeVente: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      func: { getImg, formatDate },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    logoSociete() {
      if (this.societeActive) {
        return this.societeActive.logo;
      }
      return '';
    },
    commercial() {
      return this.recom.commercial;
    },
    commercialName() {
      return [
        this.commercial.prenom,
        this.commercial.nom ? this.commercial.nom.toUpperCase() : '',
      ].filter(Boolean).join(' ');
    },
    profil() {
      if (this.commercial.profil === 'Commercial') return 'Responsable de clientèle';
      if (this.commercial.profil === 'DirecteurCommercial') return 'Responsable Clientèle';
      if (!this.commercial.profil) return '';
      return this.commercial.profil.replace(/([a-z])([A-Z])/g, '$1 $2');
    },
  },
}
</script>
